export { default } from './MakeWaves';
export type { Props, Props as MakeWavesHeroBannerProps } from './MakeWaves';
